import { BasicRequest } from "./basicRequest";

export class UpdateFileRequest extends BasicRequest{

    public moovFileId!:number;
    public moovStepInstanceId!:number;

    constructor(){
        super();
    }
}